<template>
    <div>
        <DropDownVue :items="options"
                     :label="titles.logs"
                     :validate="$v.fileLog.id"
                     @method="handleChangeDropDown"
                     icon="fas fa-check"
                     inputKey="id"
                     itemKey="id"
                     itemValue="filename"
                     :needUpdated="false"
        />
    </div>
</template>

<script>
    import DropDownVue from '@/components/common/DropDownVue';
    import {titles} from '@/utils/general/titles';
    import {fileLog} from "../shared/models/fileLog";

    export default {
        name: "MainLog",
        components: {DropDownVue},
        data() {
            return {
                titles,
                fileLog: fileLog()
            }
        },
        props: {
            options: Array
        },
        methods: {
            handleChangeDropDown(val, inputKey) {
                this.fileLog[inputKey] = val;
                this.$emit('change',val);
            }

        },
        validations: {
            fileLog: {
                id: {}
            }
        }
    }


</script>

<style scoped>

</style>